import { module } from 'angular';
import AgentComponent from './agent.component';

export default module('app.agent', [])
	.component('agent', AgentComponent)
	.name;
